import Api from '@/shared/services/Api'


export default 
{

	get() {
		return Api().get('post-get')
	},

	delete(id) {
		return Api().get('post-delete?id='+id)
	},

	getOne(id) {
		return Api().get('post-get-one?id='+id)
	},

	create(data) {
		return Api().post('post-create', data)
	},

	update(data) {
		return Api().post('post-update', data)
	},

	getPresentation() {
		return Api().get('post-get-presentation')
	}

}